import { Component, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { AssetEvent } from 'src/app/models/vr-events/AssetEvent';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { VrEventTriggerService } from 'src/app/services/vr-event-trigger.service';
import { VrEventTypeService } from 'src/app/services/vr-event-type.service';
import { VrEventService } from 'src/app/services/vr-event.service';

@Component({
  selector: 'app-video-actions',
  templateUrl: './video-actions.component.html',
  styleUrls: ['./video-actions.component.scss'],
})
export class VideoActionsComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;

  public currentEventIndex: number = -1;
  public assetEvent: AssetEvent = null;
  public paginateConfig: any;
  public currentScene: Scene = null;
  public selectOptions: any;

  constructor(  
    public deepCopyService: DeepCopyService,
    public vrEventTypeService: VrEventTypeService,
    public vrEventService: VrEventService,
    public vrEventTriggerService: VrEventTriggerService,
  ) { 
    this.paginateConfig = {
      itemsPerPage: 3,
      currentPage: 1
    };

    this.selectOptions = {
      cssClass: 'quizard-select'
    }
  }

  ngOnInit( ) {
    this.resetAssetEvent();
    this.currentScene = this.existingScenes.find(s => s.sceneId == this.assetInScene.sceneAssetRelation.sceneId);
  }

  editAction(index: number) {
    this.currentEventIndex = index;

    this.assetEvent = this.deepCopyService.deepCopy(this.assetInScene.events[this.currentEventIndex]);
  }

  cancelAction() {
    this.resetAssetEvent();
  }

  saveAction() {
    if (this.assetEvent.eventTypeId <= 0 
      || Number(this.assetEvent.linkedContentId) < 0
      || this.assetEvent.eventTriggerId <= 0)
      return;

    if (this.currentEventIndex >= 0) {
      this.assetInScene.events[this.currentEventIndex] = this.deepCopyService.deepCopy(this.assetEvent);
    } else {
      this.assetInScene.events.push(this.deepCopyService.deepCopy(this.assetEvent));
    }

    this.resetAssetEvent();
  }

  deleteAction(index: number) {
    this.assetInScene.events.splice(index, 1);
  }

  resetAssetEvent() {
    this.currentEventIndex = -1;
    this.assetEvent = this.vrEventService.getNewVrEvent() as AssetEvent;
  }

  getEventTypes() {
    return this.vrEventTypeService.types;
  }

  getEventType(eventTypeId) {
    return this.vrEventTypeService.getType(eventTypeId);
  }

  isMediaEventType(eventTypeId: number) {
    return this.vrEventService.isMediaEventType(eventTypeId);
  }

  isObjectEventType(eventTypeId: number) {
    return this.vrEventService.isObjectEventType(eventTypeId);
  }

  shouldLinkToItself(eventTypeId: number){    
    return this.getEventType(eventTypeId) == "Hide Object";
  }

  getAssetName(sceneAssetRelationId: number): string {
    let asset = this.existingAssetsInScene.find(a => a.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId);
    if(this.assetInScene.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId || sceneAssetRelationId == 0)
      return "(Itself)";
    else if (asset)
      return asset.baseAsset.name;
    else
      return "";
  }

  getSceneName(sceneId: number): string {
    return this.existingScenes.find(s => s.sceneId == sceneId).name;
  }

  getActiveAssetsInScene(): AssetInScene[] {
    return this.existingAssetsInScene.filter(a => a.toBeRemoved !== true 
      && a.sceneAssetRelation.sceneId == this.assetInScene.sceneAssetRelation.sceneId 
      && a.sceneAssetRelation.sceneAssetRelationId !== this.assetInScene.sceneAssetRelation.sceneAssetRelationId);
  }

  getActiveMediaAssetsInScene(): AssetInScene[] {
    return this.existingAssetsInScene.filter(a => a.toBeRemoved !== true 
      && a.sceneAssetRelation.sceneId == this.assetInScene.sceneAssetRelation.sceneId 
      && a.sceneAssetRelation.sceneAssetRelationId !== this.assetInScene.sceneAssetRelation.sceneAssetRelationId 
      && [5,6].includes(a.baseAsset.assetTypeId));
  }

  getActiveScenes(): Scene[] {
    return this.existingScenes.filter(s => s.active == true);
  }

}
